/**
 * @version: v2.0.0-1
 * @author: Keval Bhatt
 * @copyright: Copyright (c) 2015 Keval Bhatt. All rights reserved.
 * @license: Licensed under the MIT license. See http://www.opensource.org/licenses/mit-license.php
 * @website: http://kevalbhatt.github.io/timezone-picker/
 */

import $ from 'jquery';

const findValue = (key, value, data) => {
  const referObj = [];
  let i = 0;
  let j = 0;
  for (i; i < data.length; i++) {
    if (data[i][key] === value) {
      referObj.push($.extend(true, {}, data[i]));
    }
  }

  for (j; j < referObj.length; j++) {
    delete referObj[j].points;
    delete referObj[j].pin;
  }
  return referObj;
};

/**
 * [generateElement description]
 * @param  {[Jquery Object]}  element     [selector]
 * @param  {[type]}  attr [description]
 * @param  {[javascript Object or text]}  chilled      [If we pass javascript object or  array it will append all chilled and if you pass string it will add string(value) inside element ]
 * @param  {Boolean} isSvg       [If it is svg then it will create svg element]
 * @return {[type]}              [description]
 */

const generateElement = ({
  element, attr, chilled = false, isSvg = false
}) => {
  let elementObject;
  if (isSvg) {
    elementObject = document.createElementNS('http://www.w3.org/2000/svg', element);
  } else {
    elementObject = document.createElement(element);
  }
  if (attr) {
    Object.keys(attr).forEach((key) => {
      elementObject.setAttribute(key, attr[key]);
    });
  }
  if (chilled) {
    if (chilled instanceof Array) {
      Object.keys(chilled).forEach((chilleds) => {
        elementObject.appendChild(chilled[chilleds]);
      });
    } else if (typeof chilled === 'string') {
      elementObject.innerHTML = chilled;
    } else {
      elementObject.appendChild(chilled);
    }
  }
  return elementObject;
};

export {
  generateElement,
  findValue,
};
